export const BACKEND_API = "https://acc2.api.supergitsa.com/api/v1";
//export const BACKEND_API = 'https://jzq6qslp-8081.asse.devtunnels.ms/api/v1'
// export const BACKEND_API = 'https://mq85j3ll-8005.inc1.devtunnels.ms/api/v1'
// export const BACKEND_API = 'https://mq85j3ll-8081.inc1.devtunnels.ms/api/v1'
// export const BACKEND_API = "https://98qq51qq-8081.asse.devtunnels.ms/api/v1";
// export const BACKEND_API = 'https://fairly-notable-koala.ngrok-free.app/api/v1'
// export const BACKEND_API = 'https://90j4c2m1-8081.asse.devtunnels.ms/api/v1'
// export const BACKEND_API = "http://localhost:8081/api/v1";
// export const BACKEND_API = "https://1nbnwrhl-8081.inc1.devtunnels.ms/api/v1"
//export const BACKEND_API = 'https://jzq6qslp-8081.asse.devtunnels.ms/api/v1'
// export const BACKEND_API = 'http://192.168.1.47:8081/api/v1'
